module.exports = new __parcel__URL__("intent-templates-dark.40747ea5.svg").toString();